import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { AppService } from '@app/services/app/app.service';
import { UrlService } from '@core/services/url/url.service';
import { VersionsEditorService, VersionsViewService } from '@app/services/app/versions.service';
import { VersionMessageContext } from '@core/constants/version-message-context.constants';

import * as Objects from '@core/objects';
import { AccessVersion } from '@app/models/access';

@Component({
    selector: 'version-details-content-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss']
})
export class VersionsDetailsContentMessagesComponent implements OnInit, OnDestroy {
    // msg available contexts: used to select and filter the messages to display
    public readonly VERSION_MESSAGE_CONTEXT = VersionMessageContext;

    /* 15-12-2022 ==> version messages component no longer have feedback meesages or approval info inside. */

    @Input() version: Objects.Version;

    public access: AccessVersion;

    public user: Objects.User = null;
    public versionMessages: Array<Objects.VersionMessage> = null;
    public prefixUrl: string = '';
    public messageAddUrl: string = '';

    protected messagesSubscriptor: Subscription;
    protected appSubscriptor: Subscription;
    protected accessSubscriptor: Subscription;  
    protected urlSubscriptor: Subscription; 
    
    constructor(
        public appSrv: AppService,
        private versionsViewSrv: VersionsViewService, 
        private urlSrv: UrlService,
        private activeRoute: ActivatedRoute,
        private editorVersionSrv: VersionsEditorService 
    ) { }

    ngOnInit() {
        // When go from version to version (since jan-2024) get the version id and if changed clear messages.
        this.urlSubscriptor = this.activeRoute.params.subscribe((params: any) => {
            // Get the 'vid' parameter from the route and cast to number
            const routeVid = params.vid as number;
            if(routeVid){
                if(this.version.id && routeVid != this.version.id){
                    this.versionMessages = null;
                }
            }
        });

        this.prefixUrl = "/versions/"+ this.version.id;
        this.messageAddUrl = this.urlSrv.build(this.prefixUrl + "/messages");

        this.appSubscriptor = this.appSrv.getSession().subscribe(session => this.user = session.current.user);

        this.messagesSubscriptor = this.versionsViewSrv.selectComments().subscribe((messages: Array<Objects.VersionMessage>) => {
            // Here we filter the messages by context to get the real version messages only 
            if(messages != null){
                this.versionMessages = messages.filter((m:Objects.VersionMessage) => m.context == this.VERSION_MESSAGE_CONTEXT.DEFAULT);
            }
        });

        this.accessSubscriptor = this.editorVersionSrv.selectAccessAll().subscribe((access: AccessVersion)=> this.access = access);
    }

    ngOnDestroy() {
        this.appSubscriptor.unsubscribe();
        this.messagesSubscriptor.unsubscribe();
        this.accessSubscriptor.unsubscribe();
        this.urlSubscriptor.unsubscribe();
    }

    onUpdateMessages(message: Objects.Message) {
        this.versionsViewSrv.loadComments();
    }

    onDeleteMessage(message: Objects.Message) {
        this.versionsViewSrv.loadComments();
    }

}
